import React from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "./Footer";

const navLinks = [
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/popia", label: "POPIA Notice" },
  { to: "/legal/contact", label: "Contact" },
];

const LegalLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Themed Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="flex items-center justify-center mr-3 px-4 py-2">
              <img
                src="/logo.svg"
                alt="TyreLink Logo"
                className="w-[140px] max-w-[140px] h-auto object-contain mx-auto"
                style={{ display: 'block' }}
              />
            </div>
          </Link>
          <nav className="hidden gap-4 md:flex">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium px-3 py-2 rounded transition-colors ${
                  location.pathname === link.to
                    ? "bg-blue-600 text-white"
                    : "text-gray-600 hover:bg-blue-50 hover:text-blue-700"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Footer />

      {/* Mobile Legal Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 flex md:hidden justify-around py-2 shadow-lg">
        {navLinks.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`flex-1 text-center text-xs font-medium px-2 py-2 rounded transition-colors ${
              location.pathname === link.to
                ? "bg-blue-600 text-white"
                : "text-gray-600 hover:bg-blue-50 hover:text-blue-700"
            }`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default LegalLayout;